import { hasPermission } from "@/router/protected-routes"
import type { RouteRecordRaw } from "vue-router"

const assessmentsRoutes: RouteRecordRaw[] = [
  {
    path: "",
    name: "assessmentList",
    component: () => import("@/templates/assessments/AssessmentList.vue")
  },
  {
    path: "create/:assessmentId(\\d+)?",
    name: "assessmentCreate",
    component: () => import("@/templates/assessments/AssessmentCreate.vue"),
    meta: { breadcrumb: "assessments.list.buttons.new" },
    beforeEnter: () => {
      return hasPermission("/api/v1/assessments", "post")
    }
  },
  {
    path: "view/:assessmentId(\\d+)",
    name: "assessmentView",
    component: () => import("@/templates/assessments/AssessmentCreate.vue"),
    meta: { breadcrumb: "assessments.assessment" },
    beforeEnter: () => {
      return hasPermission("/api/v1/assessments", "get")
    }
  }
]

export default assessmentsRoutes
